import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import "./harvestingDetails.css";
import Dialog from '@mui/material/Dialog';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';

import { authKey, GET_RB_HARVEST_LIST, HIT_RB_HARVEST, GET_STAKEHOLDER_CATEGORY } from '../../../common/URLs';
import Moment from 'moment';
import { useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import jwt from 'jwt-decode';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { HavestingDonePopOver } from "./havestingDonePopOver";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES, NO_DATA_AVAILABLE } from "../../../common/constants";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { Box, Card, CardContent, Fab, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import apiClient from "../../../axios";

function HarvestingDetails(props) {

    const scheduleItem = useLocation().state?.selectedRow;
    const [harvestingDate, setHarvestingDate] = useState(null);
    const navigate = useNavigate();
    const [harvestingData, setHarvestingData] = useState([]);
    const [harvestingDone, setHarvestingDone] = useState(false);
    const [harvestingWeight, setHarvestingWeight] = useState();
    const [totalWeight, setTotalWeight] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalOpen1, setLogModalOpen1] = useState(false);
    const handleLogModalOpen1 = () => setLogModalOpen1(true);
    const handleLogModalClose1 = () => setLogModalOpen1(false);
    const [cofirmMessage, setConfirmMessage] = useState("");
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState();

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);


    let [harverstingFormData, setHarvestionFormData] = useState({
        "harvestingDate": '',
        "harvestorEngaged": "",
        "weight": "",
        "age": "",
        "isAvgWallThicknessGreaterthanConfig": "",
        "isAvgDiameterGreaterthanConfig": "",
        "color": "",
    });

    const [errorMessage, setErrorMessage] = useState({
        "harvestingDateError": "",
        "harvestorEngagedError": "",
        "weightError": "",
        "ageError": "",
        "isAvgWallThicknessGreaterthanConfigError": "",
        "isAvgDiameterGreaterthanConfigError": "",
        "colorError": "",

    });


    useEffect(() => {
        getHarvestingDetails();
    }, []);

    const getHarvestingDetails = () => {
        let data = {
            "weeklyScheduleNumber": scheduleItem?.weeklyScheduleNumber,
            "scheduleLineNumber": scheduleItem?.scheduleLineNumber,
            "poNumber": scheduleItem?.poStpoNumber
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_RB_HARVEST_LIST, data, { headers })
            .then(res => {
                setHarvestingData(res.data.hitHarvestDetailList);
                res.data.hitHarvestDetailList.forEach(data => {
                    if (data.harvestingCompletedDate && data.harvestingCompletedDate != "") {
                        setHarvestingDone(true);
                    }
                })
                loaderService.hideLoader();
            })
            .catch(function (err) {

                console.log(err);
                loaderService.hideLoader();
                toast.error(err.message);

            });
    };
    useEffect(() => {
        if (decoded.extension_URN) {
            getStakeDetails();
        }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    }

    const harvestingdone = (e, harvestingWeight, totalWeight) => {
        e.preventDefault();
        setHarvestingWeight(harvestingWeight);
        setTotalWeight(totalWeight)
        handleLogModalOpen1();


    }

    const harvestingProceed = () => {
        let requestData = {
            harvestingCompletedDate: Moment().format("YYYY-MM-DD") + "T00:00:00.000Z"
        }
        requestData = {
            "hitUrn": decoded.extension_URN ? decoded.extension_URN : scheduleItem?.stakeholderUrn,
            "weeklyScheduleNumber": scheduleItem.weeklyScheduleNumber,
            "scheduleLineNumber": scheduleItem.scheduleLineNumber,
            "poNumber": scheduleItem.poStpoNumber,
            "consignmentNo": scheduleItem.consignmentNo,
            "landId": scheduleItem.landId,
            ...requestData
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(HIT_RB_HARVEST, requestData, { headers })
            .then(res => {
                getHarvestingDetails();
                // setLogModalOpen(true);
                toast.success(res?.data?.message)
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);

            });
    }



    const handleChange = (e) => {
        const limit = 6;
        setHarvestionFormData({ ...harverstingFormData, [e.target.name]: e.target.value.slice(0, limit) });
        if (e.target.name === "harvestorEngaged") {
            setErrorMessage({ ...errorMessage, harvestorEngagedError: "" });
        }
        if (e.target.name === "weight") {
            setErrorMessage({ ...errorMessage, weightError: "" });
        }
        if (e.target.name === "age") {
            setErrorMessage({ ...errorMessage, ageError: "" });
        }
        if (e.target.name === "color") {
            setErrorMessage({ ...errorMessage, colorError: "" });
        }
    }

    const radioChange = (e) => {
        e.preventDefault();
        setHarvestionFormData({
            ...harverstingFormData, [e.target.name]: e.target.value,
        })

        if (e.target.name === "isAvgWallThicknessGreaterthanConfig") {
            setErrorMessage({ ...errorMessage, isAvgWallThicknessGreaterthanConfigError: "" });
        }
        if (e.target.name === "isAvgDiameterGreaterthanConfig") {
            setErrorMessage({ ...errorMessage, isAvgDiameterGreaterthanConfigError: "" });
        }
    };

    const handleDateChange = (e) => {
        if (e.format("YYYY-MM-DD")) {
            setErrorMessage({ ...errorMessage, harvestingDateError: "" });
        }
        setHarvestingDate(e.format("YYYY-MM-DD"));
    }


    const columns = [
        {
            field: 'harvestingDate', headerName: 'Date of Harvesting', width: 140,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'harvestorEngaged', headerName: 'No. of Harvesters engaged', width: 180, hide: stakeholderDetails?.category != "HIT" },
        {
            field: 'weight', headerName: 'Weight(in MT)', width: 100,
        },
        { field: 'age', headerName: 'Age of bamboo (in years)', width: 140 },
        {
            field: 'isAvgWallThicknessGreaterthanConfig', headerName: 'Average wall thickness greater than xxx', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else if (params.value === false) {
                    return 'No';
                }
            },
        },
        {
            field: 'isAvgDiameterGreaterthanConfig', headerName: 'Average diameter greater than xxx', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else if (params.value === false) {
                    return 'No';
                }
            },
        },
        { field: 'color', headerName: 'Colour', width: 100 },
    ];

    const onConfirmSave = (e) => {
        handleConfirmClose();
        submitData();
    }

    const onSaveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onSave = (e) => {
        if (!harvestingDate) {
            setErrorMessage({ ...errorMessage, harvestingDateError: "Please select date" });
        }
        else if (!harverstingFormData.harvestorEngaged) {
            setErrorMessage({ ...errorMessage, harvestorEngagedError: "Please enter no. of harvesters engaged" });
        }
        else if (!harverstingFormData.weight) {
            setErrorMessage({ ...errorMessage, weightError: "Please enter weight" });
        }
        else if (!harverstingFormData.age) {
            setErrorMessage({ ...errorMessage, ageError: "Please select age" });
        }
        else if (!harverstingFormData.color) {
            setErrorMessage({ ...errorMessage, colorError: "Please select colour" });
        }
        else if (!harverstingFormData.isAvgWallThicknessGreaterthanConfig) {
            setErrorMessage({ ...errorMessage, isAvgWallThicknessGreaterthanConfigError: "Please select" });
        }
        else if (!harverstingFormData.isAvgDiameterGreaterthanConfig) {
            setErrorMessage({ ...errorMessage, isAvgDiameterGreaterthanConfigError: "Please select" });
        }
        else {
            onSaveButtonClick();
            // submitData();
        }
    }

    const submitData = (e) => {
        let requestData = { ...harverstingFormData }

        // let harvestingDateVal = Moment(requestData['harvestingDate']).format("YYYY-MM-DD");
        // harvestingDateVal = harvestingDateVal + "T00:00:00.000Z"
        requestData.harvestingDate = harvestingDate + "T00:00:00.000Z";
        requestData = {
            "hitUrn": decoded.extension_URN ? decoded.extension_URN : scheduleItem?.stakeholderUrn,
            "weeklyScheduleNumber": scheduleItem.weeklyScheduleNumber,
            "scheduleLineNumber": scheduleItem.scheduleLineNumber,
            "poNumber": scheduleItem.poStpoNumber,
            "consignmentNo": scheduleItem.consignmentNo,
            "landId": scheduleItem.landId,
            ...requestData
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(HIT_RB_HARVEST, requestData, { headers })
            .then(res => {
                //setHarvestionFormData({});
                harverstingFormData = {
                    harvestorEngaged: 0,
                    weight: 0,
                    age: "",
                    color: "",
                    isAvgWallThicknessGreaterthanConfig: false,
                    isAvgDiameterGreaterthanConfig: false

                }
                document.getElementById("harversting_form").reset();
                setHarvestionFormData({
                    harvestorEngaged: 0,
                    weight: 0,
                    age: "",
                    color: "",
                    isAvgWallThicknessGreaterthanConfig: false,
                    isAvgDiameterGreaterthanConfig: false
                });
                setHarvestingDate(null);
                getHarvestingDetails();
                // setLogModalOpen(true);
                toast.success(res.data.message)
                // setConfirmMessage(res.data.message)
            })
            .catch(function (err) {

                console.log(err);
                toast.error(err.message);

            });
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT02</p>}
                <form autocomplete="off" onSubmit={(e) => submitData(e)} id="harversting_form">
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                            <KeyboardArrowLeftRounded />
                        </Fab> Harvesting Details
                    </Typography>

                    <Card>
                        <CardContent>
                            <Grid container spacing={1} direction="row" mt={1}>
                                <Grid item xs={12}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} lg={4}>
                                            {/* <p className='consignment-pick-up-label'>Schedule Number</p> */}
                                            <TextField fullWidth size="small" label='Schedule Number' value={scheduleItem.weeklyScheduleNumber} type="text" placeholder='Schedule Number' name="" disabled={true} />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Schedule Line No.</InputLabel>
                                                <Select label='Schedule Line No.' value={scheduleItem.scheduleLineNumber} disabled={true}>
                                                    <MenuItem value={scheduleItem.scheduleLineNumber}>{scheduleItem.scheduleLineNumber}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {!harvestingDone &&
                                            <>
                                                <Grid item xs={12} lg={4}>
                                                    <FormControl fullWidth required error={errorMessage.harvestingDateError}>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Date of Harvesting"
                                                                inputFormat="DD/MM/YYYY"
                                                                name="harvestingDate"
                                                                selected={harverstingFormData.harvestingDate}
                                                                maxDate={Moment().toDate()}
                                                                disabled={harvestingDone}
                                                                value={harvestingDate}
                                                                onChange={(e) => handleDateChange(e)}
                                                                renderInput={(params) => <TextField size="small" {...params} />}
                                                            />
                                                        </LocalizationProvider>
                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.harvestingDateError}</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <TextField fullWidth required size="small"
                                                        error={errorMessage.harvestorEngagedError}
                                                        helperText={errorMessage.harvestorEngagedError}
                                                        type="number"
                                                        onFocus={handleNumberFieldFocus}
                                                        label='No. of Harvesters engaged'
                                                        value={harverstingFormData.harvestorEngaged}
                                                        name="harvestorEngaged"
                                                        onChange={(e) => handleChange(e)}
                                                        maxLength={6}
                                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <TextField fullWidth required type="number" onFocus={handleNumberFieldFocus} size="small"
                                                        error={errorMessage.weightError}
                                                        helperText={errorMessage.weightError}
                                                        label='Weight(in MT)'
                                                        value={harverstingFormData.weight}
                                                        name="weight"
                                                        onChange={(e) => handleChange(e)}
                                                        maxLength={6}
                                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <FormControl fullWidth size="small" required error={errorMessage.ageError}>
                                                        <InputLabel>Age of bamboo (in years)</InputLabel>
                                                        <Select label='Age of bamboo (in years)' value={harverstingFormData.age} name="age" onChange={(e) => handleChange(e)}>
                                                            <MenuItem value="" disabled selected>Age Of Bamboo</MenuItem>
                                                            <MenuItem value={'>4'}>greater than 4</MenuItem>
                                                            <MenuItem value={'<6'}>less than 6</MenuItem>
                                                        </Select>
                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.ageError}</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <FormControl fullWidth required error={errorMessage.isAvgWallThicknessGreaterthanConfigError}>
                                                        <FormLabel id="demo-row-radio-buttons-group-label">Average wall thickness greater than xxx</FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                        >
                                                            <FormControlLabel name="isAvgWallThicknessGreaterthanConfig" value={true || ''} onChange={(e) => radioChange(e)} control={<Radio />} label="Yes" />
                                                            <FormControlLabel name="isAvgWallThicknessGreaterthanConfig" value={false || ''} onChange={(e) => radioChange(e)} control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.isAvgWallThicknessGreaterthanConfigError}</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <FormControl fullWidth required error={errorMessage.isAvgDiameterGreaterthanConfigError}>
                                                        <FormLabel id="demo-row-radio-buttons-group-label">Average diameter greater than xxx</FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                        >
                                                            <FormControlLabel name="isAvgDiameterGreaterthanConfig" value={true || ''} onChange={(e) => radioChange(e)} control={<Radio />} label="Yes" />
                                                            <FormControlLabel name="isAvgDiameterGreaterthanConfig" value={false || ''} onChange={(e) => radioChange(e)} control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.isAvgDiameterGreaterthanConfigError}</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} lg={4}>
                                                    <FormControl fullWidth size="small" required error={errorMessage.colorError}>
                                                        <InputLabel>Colour</InputLabel>
                                                        <Select label="Colour" value={harverstingFormData?.color} name="color" onChange={(e) => handleChange(e)}>
                                                            <MenuItem value="" disabled selected>Colour</MenuItem>
                                                            <MenuItem value="Green">Green</MenuItem>
                                                            <MenuItem value="Grey">Grey</MenuItem>
                                                        </Select>
                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.colorError}</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                            </>

                                        }
                                        <Grid item xs={12} lg={12}>
                                            {harvestingData?.length > 0 &&
                                                <Box style={{ height: 300, width: '100%' }}>
                                                    {
                                                        harvestingData &&
                                                        <DataGrid rows={harvestingData}
                                                            columns={columns}
                                                            pageSize={10}
                                                            // getRowId={(row) => row.invoiceNo}
                                                            components={{ Toolbar: QuickSearchToolbar }}
                                                        />
                                                    }

                                                </Box>
                                            }
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card >
                    < Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }
                    }>
                        {!harvestingDone && (localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category == "HIT") ?
                            <>
                                <Button variant="contained" sx={{ minWidth: 100 }} type="submit" onClick={(e) => onSave(e)} >Save</Button>
                                {harvestingData?.length > 0 && <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} disabled={harvestingDone} onClick={(e) => harvestingdone(e, harvestingData.reduce((accum, item) => Number(accum) + Number(item.weight), 0), scheduleItem.scheduleRbCbQuantity)}>Harvesting Done</Button>}
                            </>
                            : null
                        }
                    </Box >
                </form>
            </Container >
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />

            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <ConfirmPopover title={cofirmMessage} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLogModalOpen(false)}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog maxWidth='md' fullWidth open={logModalOpen1}>
                <DialogContent>
                    <HavestingDonePopOver harvestingDone={harvestingProceed} handleLogModalClose={handleLogModalClose1} harvestingWeight={harvestingWeight} scheduledWeight={totalWeight} />
                </DialogContent>
            </Dialog>
        </>
    )


}
export default HarvestingDetails;